
Modernizr.on('cssgrid', (result) => {
    if (!result) {
        document.body.classList.add('no-grid');
    }
});



// WEBPACK FOOTER //
// ./src/js/features/detectBrowser.js